(() => {
  'use strict';
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const coarse = matchMedia('(pointer: coarse)');
  const wide = matchMedia('(min-width: 1000px)');
  const entries = new Map();
  const active = () => !reduced.matches && document.body.dataset.motion !== 'off' && !window.Shopify?.designMode;
  function mount(el) {
    if (entries.has(el)) return;
    const life = new AbortController();
    let context;
    function build() {
      context?.revert();
      context = null;
      if (!active()) return;
      context = gsap.context(self => {
        const once = target => ({trigger:target,start:'top 92%',once:true});
        if (el.matches('.mint-stage')) {
          gsap.from(el.querySelectorAll('.title-line > span'), {yPercent:106,duration:.8,stagger:.12,ease:'power3.out',clearProps:'transform'});
          gsap.from(el.querySelector('.mint-object'), {y:28,rotation:5,scale:.95,duration:1.15,ease:'power3.out',clearProps:'transform'});
          const floating = el.querySelectorAll('.stage-mint');
          gsap.from(floating, {scale:.5,opacity:0,duration:.7,stagger:.16,delay:.3,ease:'back.out(1.25)',clearProps:'opacity,transform'});
          const floaters = [...floating].map((mint,i)=>gsap.to(mint.querySelector('svg'),{y:i?-12:13,rotation:i?12:-10,duration:3+i*.7,repeat:-1,yoyo:true,ease:'sine.inOut'}));
          const orbit = el.querySelector('.stage-orbit ellipse');
          gsap.fromTo(orbit,{strokeDashoffset:1},{strokeDashoffset:0,duration:1.8,ease:'power2.out'});
          ScrollTrigger.create({trigger:el,start:'top bottom',end:'bottom top',onToggle:self=>floaters.forEach(t=>self.isActive&&!document.hidden?t.play():t.pause())});
          document.addEventListener('visibilitychange',()=>{const r=el.getBoundingClientRect();floaters.forEach(t=>!document.hidden&&r.bottom>0&&r.top<innerHeight?t.play():t.pause());},{signal:life.signal});
          if (!coarse.matches) {
            const stage = el.querySelector('.mint-object');
            const leanX = gsap.quickTo(stage,'rotationY',{duration:.9,ease:'power2.out'});
            const leanY = gsap.quickTo(stage,'rotationX',{duration:.9,ease:'power2.out'});
            const move = event=>{const r=stage.getBoundingClientRect();leanX((event.clientX-r.left-r.width/2)/r.width*7);leanY(-(event.clientY-r.top-r.height/2)/r.height*6);};
            stage.addEventListener('pointermove',move,{signal:life.signal});
            stage.addEventListener('pointerleave',()=>{leanX(0);leanY(0);},{signal:life.signal});
          }
        }
        if (el.matches('.mint-moments')) {
          const figures=el.querySelectorAll('.mint-moment figure');
          gsap.from(figures,{y:32,clipPath:'inset(8% 0 0 0)',duration:1,stagger:.14,ease:'power3.out',scrollTrigger:once(el.querySelector('.moment-track')),clearProps:'transform,clipPath'});
          if(!coarse.matches && wide.matches) figures.forEach(figure=>gsap.fromTo(figure.querySelector('img'),{yPercent:3,scale:1.08},{yPercent:-3,scale:1.08,ease:'none',scrollTrigger:{trigger:figure,start:'top bottom',end:'bottom top',scrub:1}}));
          gsap.from(el.querySelector('.mint-directions'),{y:15,opacity:.4,duration:.7,ease:'power2.out',scrollTrigger:once(el.querySelector('.mint-directions')),clearProps:'transform,opacity'});
        }
        if (el.matches('.coffee-section')) {
          // The calculator owns the final level; an event starts its one entrance fill.
          ScrollTrigger.create({trigger:el.querySelector('.coffee-visual'),start:'top 85%',once:true,onEnter:()=>self.ignore(()=>el.dispatchEvent(new Event('neuro:coffee-enter')))});
          gsap.from(el.querySelectorAll('.coffee-steam path'),{strokeDashoffset:1,opacity:0,duration:1.4,stagger:.2,ease:'power2.out',scrollTrigger:once(el.querySelector('.coffee-visual'))});
        }
        if (el.matches('.bundle-section')) {
          gsap.from(el.querySelector('.bundle-sculpture'),{clipPath:'inset(8% 5% 8% 5%)',duration:.9,ease:'power3.out',scrollTrigger:once(el.querySelector('.bundle-sculpture')),clearProps:'clipPath'});
          gsap.from(el.querySelectorAll('.bundle-option'),{x:20,opacity:.3,duration:.6,stagger:.1,ease:'power2.out',scrollTrigger:once(el.querySelector('.bundle-choice')),clearProps:'transform,opacity'});
        }
        if (el.matches('.signup-section')) {
          gsap.fromTo(el.querySelector('.offer-stroke path'),{strokeDashoffset:1},{strokeDashoffset:0,duration:1.2,ease:'power2.inOut',scrollTrigger:once(el)});
          gsap.from(el.querySelector('.offer-number'),{y:20,rotation:-7,duration:.8,ease:'back.out(1.1)',scrollTrigger:once(el),clearProps:'transform'});
        }
      },el);
    }
    // Each rebuild replaces all pointer listeners together with its GSAP context.
    entries.set(el,{destroy(){life.abort();context?.revert();}});
    build();
  }
  function init(scope=document) {
    for (const [el,item] of entries) if(!el.isConnected){item.destroy();entries.delete(el);}
    const selector='.mint-stage,.mint-moments,.coffee-section,.bundle-section,.signup-section';
    const nodes=[...(scope.matches?.(selector)?[scope]:[]),...scope.querySelectorAll(selector)];
    nodes.forEach(mount);
    ScrollTrigger.refresh();
  }
  function rebuild(){for(const entry of entries.values())entry.destroy();entries.clear();init();}
  document.addEventListener('neuro:motion',rebuild);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [el,item] of entries)if(event.target.contains(el)){item.destroy();entries.delete(el);}});
  document.addEventListener('shopify:section:reorder',()=>ScrollTrigger.refresh());
  window.addEventListener('pagehide',()=>{for(const entry of entries.values())entry.destroy();entries.clear();});
  window.addEventListener('pageshow',event=>{if(event.persisted)init();});
  reduced.addEventListener('change',rebuild);
  coarse.addEventListener('change',rebuild);
  wide.addEventListener('change',rebuild);
  init();
})();
